<template>
  <div v-if="SHOW_LOGO">
    <v-touch tag="div" @tap="goActivty()" class="test-coupon">
      <img :src="logoSrc" />
    </v-touch>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import APIS from "@/apis";
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
export default {
  name: "",
  props: ["inDetailGo", "showProps", "isInnerChannel"],
  data() {
    return {
      msg: "",
    };
  },
  computed: {
    ...mapState([
      'adsense',
    ]),
    adFloatConfig() {
      let r = {}
      r = this.adsense.find(element => element['adsenseType'] == 2)
      // console.log('--- 获取到的浮标数据 ---', r)
      return r
    },
    SHOW_LOGO(){
      return this.showProps && (!this.isDepression || this.useAB) && this.logoSrc
    },

    // 是否是抑郁单品
    isDepression () {
      if (this.$route.name === 'testDetail' && +this.$route.params.testId === 696) {
        return true
      }
      return false
    },

    logoSrc () {
      if (this.isHideChannel) return ''
      let config = this.adFloatConfig
      if (!config) {
        return
      }
      // console.log('--- 弹窗背景 内部渠道 ---', this.CHANNEL_INTERNALCHANNEL)
      let isInternal = config.channelScope.includes('1') && this.CHANNEL_INTERNALCHANNEL
      let isExternal = config.channelScope.includes('2') && !this.CHANNEL_INTERNALCHANNEL
      if (isInternal || isExternal) {
        const now = new Date()
        if (config && (now > new Date(config.startTime.replace(/-/g, "/"))) && (now < new Date(config.endTime.replace(/-/g, "/")))) {
          // console.log('--- 弹窗在开始和结束时间内 ---',)
          return config.image
        } else {
          return ''
        }
      } else {
        return ''
      }
    }
  },
  methods: {
    goActivty(){
      let type = 'logo'
      this.goIntoDialog(type, this.adFloatConfig)
    },
  },
  components: {},
  mounted() {
  },
  watch: {},
  beforeDestroy() {
    //销毁事件
  }
};
</script>

<style scoped lang="scss">
@import "../../scss/function";
.test-coupon {
  position: fixed;
  z-index: 5;
  width: topx(180rem);
  top: topx(650rem);
  right: 0;
  overflow: hidden;
  img {
    display: block;
    width: 100%;
    height: auto;
  }
}
.test-coupon-hand {
  position: fixed;
  z-index: 5;
  border-radius: topx(84rem);
  width: topx(172rem);
  right: topx(-10rem);
  top: topx(450rem);
  img {
    width: 100%;
    height: auto;
  }
}
.animation-logo1 {
  transform: rotate(90deg);
  transform-origin: right bottom;
  animation: start-in 1s linear 0.5s;
}

@keyframes start-in {
  0% {
    transform-origin: right bottom;
    transform: rotate(90deg);
  }
  50% {
    transform-origin: right bottom;
    transform: rotate(0deg);
  }
  100% {
    transform-origin: right bottom;
    transform: rotate(90deg);
  }
}
.animation-logo2 {
  transform: rotate(90deg);
  transform-origin: right bottom;
  animation: start-on 0.5s linear 1.5s;
}

@keyframes start-on {
  0% {
    transform-origin: right bottom;
    transform: rotate(90deg);
  }
  100% {
    transform-origin: right bottom;
    transform: rotate(0deg);
  }
}
.animation-logo3 {
  transform: rotate(90deg);
  transform-origin: right bottom;
  animation: end-on 0.8s linear 2s infinite;
  opacity: 0;
}
@keyframes end-on {
  0% {
    transform-origin: right bottom;
    transform: rotate(0deg);
    opacity: 1;
  }
  50% {
    transform-origin: right bottom;
    transform: rotate(16deg);
    opacity: 1;
  }
  100% {
    transform-origin: right bottom;
    transform: rotate(0deg);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/show/couponLogo.vue